import styled from "styled-components";

export const LegendContainer = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;

  display: flex;
  flex-direction: column;

  height: 21vh;
  width: 8vh;

  z-index: 1000;
  background: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 5px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const LegendColor = styled.span`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

export const LegendValue = styled.span`
  font-size: 14px;
`;
